import React, { useState, useMemo } from 'react';
import { translate } from '@utils/i18n';
import useDebounce from '@hooks/useDebounce';
import SearchPanel from '@components/SearchPanel';
import { namespace } from './constants';
import { useLongFormTemplates } from './hooks/useLongFormTemplatesMutations';
import LongFormTemplatesTable from './LongFormTemplatesTable';
import LongFormTemplateDetailModal from './components/LongFormTemplateDetailModal';
import LongFormTemplateImportModal from './components/LongFormTemplateImportModal';
import '../FormLibrary/styles.scss';
function LongFormTemplatesSettings({ territoriesForSelect = [] }) {
    const [searchText, setSearchText] = useState('');
    const searchTextDebounced = useDebounce(searchText);
    const { data: templates = [], isLoading } = useLongFormTemplates();
    const [openDetailTemplate, setOpenDetailTemplate] = useState(null);
    const [isImportFormOpen, setIsImportFormOpen] = useState(false);
    const onClickItem = (template) => {
        setOpenDetailTemplate(template);
    };
    // Filter templates by search text
    const filteredTemplates = useMemo(() => {
        if (!searchTextDebounced.trim())
            return templates;
        const lower = searchTextDebounced.toLowerCase();
        return templates.filter((template) => template.name.toLowerCase().includes(lower));
    }, [searchTextDebounced, templates]);
    // Sort templates by name
    const sortedTemplates = useMemo(() => {
        return [...filteredTemplates].sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
    }, [filteredTemplates]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "workspace__body longFormTemplatesContainer" },
            React.createElement("div", { className: "workspace__major--listing" },
                React.createElement("div", { className: "workspace__header" },
                    React.createElement("div", { className: "header__main" },
                        React.createElement("h1", { className: "workspace__title" }, translate('title', { namespace })))),
                React.createElement("article", { id: "filters", className: "qmb-filters" },
                    React.createElement("button", { type: "button", className: "qmb-control mt-1 brushaway-button", onClick: () => setIsImportFormOpen(true) },
                        React.createElement("i", { className: "fa-light fa-circle-plus" }),
                        translate('import_button', { namespace })),
                    React.createElement("div", { className: "filters__group--search" },
                        React.createElement(SearchPanel, { value: searchText, placeholder: translate('search', { namespace: 'filters' }), onChange: setSearchText }))),
                React.createElement(LongFormTemplatesTable, { templates: sortedTemplates, isLoading: isLoading, onClickItem: onClickItem, territories: territoriesForSelect }))),
        React.createElement(LongFormTemplateDetailModal, { template: openDetailTemplate, onClose: () => setOpenDetailTemplate(null), territories: territoriesForSelect }),
        React.createElement(LongFormTemplateImportModal, { isOpen: isImportFormOpen, onClose: () => setIsImportFormOpen(false) })));
}
export default LongFormTemplatesSettings;
